<!--suppress ALL -->
<script lang="ts">
import {bankAccounts} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class BankAccountSelect extends Vue {

    @Prop({default: bankAccounts[0].value, type: String})
    public bank: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({type: String, default: null})
    public type: any;

    @Prop({type: String, default: null})
    public message: any;

    @Prop({type: Boolean, default: false})
    public disabled: any;

    public onSelectWilayah(param: any) {
      this.$emit('update:bank', param || bankAccounts[0].value);
      this.$emit('bank-selected', param);
    }

    public render(createElement: Function) {
      const {$t, bank, isFullwidth, message, type} = this;

      const mainAttr: any = {
        props: {
          value: bank,
          isFullwidth, placeholder: `${$t('label.choose')} ${$t('label.bank')}`
        },
        attrs: {disabled: this.disabled},
        on: {change: this.onSelectWilayah}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(bankAccounts).map((item: any) => {
        const option: any = {attrs: {value: item.value}};

        return createElement('option', option, item.label.toUpperCase());
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label: $t('label.bank'), message, type}}, [main]);
    }
  }
</script>
